import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import { FiEdit2, FiTrash2, FiMoreVertical } from "react-icons/fi";
import { useModalManager, useManagedModal } from "../../context/ModalContext";
import StageModal from "./StageModal";
import EditStageModal from "./EditStageModal";
import DeleteStageModal from "./DeleteStageModal";

const PipelineModal = ({ show, handleClose }) => {
  const [showStage, setShowStage] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [currentStage, setCurrentStage] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const { openModal } = useModalManager();
  const handleManagedClose = useManagedModal(
    "activity-pipeline-modal",
    show,
    handleClose,
  );
  const [showDelete, setShowDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  //   const stages = [
  //     "Inpipeline",
  //     "Follow Up",
  //     "Schedule Service",
  //   ];
  const [stages, setStages] = useState([
    "Inpipeline",
    "Follow Up",
    "Schedule Service",
  ]);

  const handleEditClick = (stage, index) => {
    setCurrentStage(stage);
    setEditIndex(index);
    setShowEdit(true);
  };

  const handleSaveEdit = () => {
    const updated = [...stages];
    updated[editIndex] = currentStage;
    setStages(updated);
    setShowEdit(false);
  };
  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDelete(true);
  };

  const handleConfirmDelete = () => {
    const updated = stages.filter((_, i) => i !== deleteIndex);
    setStages(updated);
    setShowDelete(false);
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleManagedClose}
        centered
        className="pipeline-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Pipeline</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Pipeline Name */}
            <Form.Group>
              <Form.Label>Pipeline Name *</Form.Label>
              <Form.Control />
            </Form.Group>

            {/* Pipeline Stages */}
            <div className="mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <Form.Label>Pipeline Stages *</Form.Label>
                <span
                  className="add-new"
                  onClick={() => {
                    openModal("activity-stage-modal");
                    setShowStage(true);
                    handleManagedClose();
                  }}
                >
                  + Add New
                </span>
              </div>

              <div className="stage-list">
                {stages.map((stage, index) => (
                  <div className="stage-item" key={index}>
                    <div className="stage-left">
                      <FiMoreVertical className="drag-icon" />
                      <span>{stage}</span>
                    </div>

                    <div className="stage-actions">
                      <FiEdit2 onClick={() => handleEditClick(stage, index)} />
                      <FiTrash2
                        onClick={() => handleDeleteClick(stage, index)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Access */}
            <div className="mt-3">
              <Form.Label>Access</Form.Label>

              <div className="d-flex gap-3 mt-1">
                <Form.Check
                  type="radio"
                  label="All"
                  name="access"
                  defaultChecked
                />
                <Form.Check type="radio" label="Select Person" name="access" />
              </div>
            </div>

            {/* Footer */}
            <div className="footer-actions mt-4">
              <Button variant="light" onClick={handleManagedClose}>
                Cancel
              </Button>
              <Button className="btn-orange">Add Pipeline</Button>
            </div>
          </Form>
        </Modal.Body>

        <style>
          {`
               /* Modal container */
.pipeline-modal .modal-content,
.stage-modal .modal-content {
  border-radius: 10px;
  padding: 10px;
}

/* Labels */
.form-label {
  font-size: 13px;
  font-weight: 600;
}

/* Add new */
.add-new {
  color: #ff6b00;
  font-size: 13px;
  cursor: pointer;
}

/* Stage list */
.stage-list {
  margin-top: 10px;
}

.stage-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eee;
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #fff;
}

/* Left side */
.stage-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.drag-icon {
  color: #999;
}

/* Actions */
.stage-actions {
  display: flex;
  gap: 10px;
  color: #666;
  cursor: pointer;
}

/* Orange focus */
.form-control:focus,
.form-select:focus {
  border-color: #ff6b00 !important;
  box-shadow: 0 0 0 0.1rem rgba(255, 107, 0, 0.25) !important;
}

/* Radio button orange */
.form-check-input:checked {
  background-color: #ff6b00;
  border-color: #ff6b00;
}

/* Footer */
.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Button */
.btn-orange {
  background-color: #ff6b00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background-color: #e65c00;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .footer-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }

  .stage-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}`}
        </style>
      </Modal>

      {/* Stage Modal */}
      <StageModal show={showStage} handleClose={() => setShowStage(false)} />
      <EditStageModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        stageName={currentStage}
        setStageName={setCurrentStage}
        onSave={handleSaveEdit}
      />
      <DeleteStageModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        onDelete={handleConfirmDelete}
      />
    </>
  );
};

export default PipelineModal;
